$(function() {

  $('.jsSlideKitAgree').on('click', function(){
    if($(this).prop('checked') === true) {
      $(this).closest('.jsSlideKitDownload').find('.jsSlideKitDisableBtn').hide();
      $(this).closest('.jsSlideKitDownload').find('.jsSlideKitEnableBtn').show().css('display','inline-block');
    } else {
      $(this).closest('.jsSlideKitDownload').find('.jsSlideKitEnableBtn').hide();
      $(this).closest('.jsSlideKitDownload').find('.jsSlideKitDisableBtn').show().css('display','inline-block');
    }
  });

});